import styled from 'styled-components';

export const Timer=styled.span`
font-weight:500;
`